import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
// export const fetchdatasss = (special: any) => ({
//     type: 'FETCH_SPEC_SUCCESS',
//     payload: special,
// });
// export const fetchCountries = (country: any) => ({
//     type: 'FETCH_COUN_SUCCESS',
//     payload: country,
// });
export const updateDoctors = (edit: any) => ({
    type: 'FETCH_EDIT_SUCCESS',
    payload: edit,
});
export const verify = (verify: any) => ({
    type: 'FETCH_VER_SUCCESS',
    payload: verify,
});
export const removeData = (remove: any) => ({
    type: 'FETCH_REMOVE_SUCCESS',
    payload: remove,
});
export const fetchAssistantList = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,uid:uid};
            const apiname = SUPRIVISOR_API.sassistant;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
// export const getSpeciality = (uid:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = {userid:uid};
//             const apiname = SUPRIVISOR_API.speciality;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(fetchdatasss(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
// export const getCountries = () => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = {};
//             const apiname = SUPRIVISOR_API.countrydata;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(fetchCountries(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
export const editAssistants = (FirstName:any,lastName:any,Email:any,Phone:any,Address:any,aid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {fname:FirstName,lname:lastName,email:Email,phone:Phone,address:Address,aid:aid,q:3};
            const apiname = SUPRIVISOR_API.sassistant;
            const response = await LoginService.getData(apiname,payload);
            dispatch(updateDoctors(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const verifyAdd = (Address:any,aid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {address:Address,userid:aid,q:1};
            const apiname = SUPRIVISOR_API.verifyadd;
            const response = await LoginService.getData(apiname,payload);
            dispatch(verify(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const DeleteAssistant = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {aid:id,q:4};
            const apiname = SUPRIVISOR_API.sassistant;
            const response = await LoginService.getData(apiname,payload);
            dispatch(removeData(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};